import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

// ✅ Images
import bgImage from "../../images/bg/testimonial-bg.png";
import gifShape from "../../images/icon/animated-gif03.gif";
import avatar1 from "../../images/avatar/img01.jpg";
import avatar2 from "../../images/avatar/img02.jpg";
import avatar3 from "../../images/avatar/img03.jpg";
import avatar4 from "../../images/avatar/img04.jpg";
import avatar5 from "../../images/avatar/img05.jpg";

const testimonials = [
  {
    id: 1,
    source: "Trustpilot",
    rating: "5.0",
    content:
      '"Best prices I found for TikTok views. Orders start in seconds and my clients are happy. I refill every day."',
    name: "Riya Mehta",
    designation: "Reseller",
    avatar: avatar1,
  },
  {
    id: 2,
    source: "Trustpilot",
    rating: "4.9",
    content:
      '"We run growth for 30 creators. This panel keeps our costs low and delivery fast. Simple dashboard, clean API."',
    name: "Miguel Torres",
    designation: "Agency Owner",
    avatar: avatar2,
  },
  {
    id: 3,
    source: "Trustpilot",
    rating: "5.0",
    content:
      '"I buy Instagram followers and likes every week. Cheap, safe, and the refill button really works."',
    name: "Sarah Clark",
    designation: "Content Creator",
    avatar: avatar3,
  },
  {
    id: 4,
    source: "Trustpilot",
    rating: "5.0",
    content:
      '"Support answers in minutes on Telegram. I moved all my reseller business here and never looked back."',
    name: "Priya Ramirez",
    designation: "Reseller",
    avatar: avatar4,
  },
  {
    id: 5,
    source: "Trustpilot",
    rating: "4.7",
    content:
      '"Low deposit, free API, stable delivery. Great for small agencies like ours. Good value for the price."',
    name: "David Park",
    designation: "Agency Owner",
    avatar: avatar5,
  },
  {
    id: 6,
    source: "Trustpilot",
    rating: "5.0",
    content:
      '"I grew my TikTok from 2k to 40k followers. Prices are honest and the team is quick to help."',
    name: "Jamie Rivera",
    designation: "Content Creator",
    avatar: avatar3,
  },
];

const TestimonialSection: React.FC = () => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".testimonial.bg_img");
    if (bgEl) bgEl.style.backgroundImage = `url(${bgImage})`;
  }, []);

  return (
    <section className="testimonial pb-150 bg_img">
      <div className="container">
        <div className="sec-title sec-title-center tes-sec-title text-center mb-50">
          <span className="sub-title mb-15">Real Reviews</span>
          <h2 className="title">
            Loved by resellers
            <img src={gifShape} alt="shape" /> and creators
          </h2>
        </div>
      </div>

      <div className="xb-testimonial-slider">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          speed={400}
          spaceBetween={30}
          autoplay={{
            delay: 6000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1700: { slidesPerView: 5 },
            1600: { slidesPerView: 4 },
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            576: { slidesPerView: 1 },
            0: { slidesPerView: 1 },
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="xb-testimonial-item">
                <div className="xb-item--inner xb-border">
                  <ul className="xb-item--rating list-unstyled ul_li">
                    <li>
                      <i className="fa-solid fa-star-sharp"></i>
                    </li>
                    <li>{item.source}</li>
                    <li>{item.rating}</li>
                  </ul>
                  <p className="xb-item--content">{item.content}</p>
                  <div className="xb-item--author ul_li">
                    <div className="xb-item--avatar">
                      <img src={item.avatar} alt={item.name} />
                    </div>
                    <div className="xb-item--holder">
                      <h3 className="xb-item--name">{item.name}</h3>
                      <span className="xb-item--desig">{item.designation}</span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
